// Exchange thread message schemas.
import { z } from 'zod';

import { idSchema, richTextSchema } from './common.js';

export const sendMessageInputSchema = z.object({
  thread_id: idSchema,
  body: richTextSchema(8000).refine((s) => s.trim().length > 0, {
    message: 'Add a message before sending.',
  }),
  attachments: z
    .array(
      z.object({
        kind: z.enum(['image', 'pdf', 'audio', 'other']),
        url: z.string().url(),
        filename: z.string().min(1).max(280),
        size_bytes: z.number().int().positive().max(10 * 1024 * 1024),
        mime: z.string().min(1).max(120),
      }),
    )
    .max(4)
    .optional(),
  client_request_id: z.string().min(8).max(64),
});
export type SendMessageInput = z.infer<typeof sendMessageInputSchema>;

export const editMessageInputSchema = z.object({
  message_id: idSchema,
  body: richTextSchema(8000).refine((s) => s.trim().length > 0, {
    message: 'Add a message before saving.',
  }),
});
export type EditMessageInput = z.infer<typeof editMessageInputSchema>;

export const markThreadReadInputSchema = z.object({
  thread_id: idSchema,
});
export type MarkThreadReadInput = z.infer<typeof markThreadReadInputSchema>;
